import useTotalNetPromoterScore from '@/api/hcp/partnerscore/hooks/nps/useTotalNetPromoterScore';
import useGetAverageCSATScore from '@/api/hcp/partnerscore/hooks/csat/useGetAverageCSATScore';
import useGetAverageCesScore from '@/api/hcp/partnerscore/hooks/ces/useGetAverageCesScore';
import useGetAveragePartnerScore from '@/api/hcp/partnerscore/useGetAveragePartnerScore';
import { type NavigationTab } from '@/storybook/components/NavigationTabList/NavigationTabList';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useGetPartnerScoreNavigation(year: number, quarter: number, surveyIdList: Array<string>) {
  const { data: overview, isLoading: isOverviewLoading } = useGetAveragePartnerScore({ year, quarter, surveyIdList });

  const { data: csat, isLoading: isCsatLoading } = useGetAverageCSATScore({ year, quarter, surveyIdList });
  const { data: effortScore, isLoading: isEffortScoreLoading } = useGetAverageCesScore({ year, quarter, surveyIdList });
  const { data: tnps, isLoading: isTnpsLoading } = useTotalNetPromoterScore({
    year,
    quarter,
    surveyIdList,
    isHcpUser: false,
  });

  return {
    overview,
    csat,
    effortScore,
    tnps,
    isOverviewLoading,
    isCsatLoading,
    isEffortScoreLoading,
    isTnpsLoading,
  };
}

export function usePartnerScoreHeader(currentTabId: NavigationTab['id']): string {
  const { t } = useTranslation();
  const pageHeaderOptions: Record<NavigationTab['id'], string> = useMemo(
    () => ({
      partnerscore: t('main.hcpOverview.overview.partnerscoreSummary.container.title'),
      csatscore: t('main.hcpOverview.overview.partnerscore.csat.title'),
      cesscore: t('main.hcpOverview.overview.partnerscore.cesscore.title'),
      npsscore: t('main.hcpOverview.overview.partnerscore.nps.title'),
    }),
    [t],
  );
  return pageHeaderOptions[currentTabId] || '';
}
